export default __webpack_public_path__ + "b514d220b4c6d163659c68ae819d8f78.svg";